import { useCallback, useMemo } from 'react'
import { useCookies } from 'react-cookie'
import { COOKIE_NAME_LOCATION_PREFERENCE } from '../constants'
import { useConfig } from '../providers/config'
import { useCountries } from './useCountries'
import { useUserCountry } from './user-country'

export const useCountryShippingDefault = () => {
	const { country: userCountry, called, error, loading } = useUserCountry()
	const { shippingCountries } = useCountries()
	const { defaultCountry } = useConfig()

	const [{ [COOKIE_NAME_LOCATION_PREFERENCE]: cookieLocationPreferenceValue }] = useCookies([
		COOKIE_NAME_LOCATION_PREFERENCE,
	])

	const cookieLocationPreferenceCountryCode = cookieLocationPreferenceValue?.countryCode

	const findCountry = useCallback(
		(countryCode) => {
			return shippingCountries.find((country) => country.code === countryCode)
		},
		[shippingCountries]
	)

	// 1 location preference (check in shipping countries)
	// 2 user country (check in shipping countries)
	// 3 default country

	const defaultShippingCountry = useMemo(() => {
		if (cookieLocationPreferenceCountryCode && findCountry(cookieLocationPreferenceCountryCode)) {
			return findCountry(cookieLocationPreferenceCountryCode)
		} else if (userCountry && findCountry(userCountry)) {
			return findCountry(userCountry)
		} else {
			return findCountry(defaultCountry)
		}
	}, [cookieLocationPreferenceCountryCode, defaultCountry, findCountry, userCountry])

	return { country: called || error ? defaultShippingCountry : {}, loading }
}
